// The old staff and permissions page. Staff and role permissions are now sections of the Settings dialog,
// so this address goes to the welcome page and opens Settings there, for anyone who can see either.
app.controller("practiceStaffController", [
	"$state",
	"Session",
	"SettingsDialog",
	function ($state, Session, SettingsDialog) {
		var section = null;
		if (Session.practice && Session.hasPermission("PRACTICE_USER_VIEW")) {
			section = "staff";
		} else if (Session.practice && Session.hasPermission("PRACTICE_ROLE_MANAGE")) {
			section = "rolePermissions";
		}
		$state.go("welcome").then(function () {
			if (section) {
				SettingsDialog.openSettings(section);
			}
		});
	},
]);
